Date.prototype.myFormat = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/**
 * 'HH:mm-HH:mm' 转换成 ['HH:mm','HH:mm']
 * @param timeSeg
 * @returns {*}
 */
export function getHourAndMinuteArray({timeSeg}) {
    return timeSeg.split('-');
}

/**
 * ['HH:mm','HH:mm'] 转换成 'HH:mm-HH:mm'
 * @param timeArray
 * @returns {string}
 */
export function getHourAndMinuteString({timeArray}) {
    return timeArray.join('-');
}

export function getNextMonthDateArray() {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    return getLatestMonthDateArrayByDate({date, delayNum: 1});
}

/**
 * 前后半年
 * @returns {[*, *]}
 */
export function getNextAndBeforeHalfYearDateArray() {
    const date = new Date();
    date.setMonth(date.getMonth() + 6);
    return getLatestMonthDateArrayByDate({date, delayNum: 12});
}

export function getLatestThreeMonthDateArray() {
    return getLatestMonthDateArrayByDate({date: new Date()})
}

export function getLatestHalfYearDateArray({formatValue} = {}) {
    return getLatestMonthDateArrayByDate({date: new Date(), delayNum: 6, formatValue});
}

export function getLatestOneYearDateArray() {
    return getLatestMonthDateArrayByDate({date: new Date(), delayNum: 12});
}

export function getCurrentDateArray(){
    var date = new Date();
    var sDate,eDate;
    sDate = date.myFormat('yyyy-M-d');
    eDate = date.myFormat('yyyy-M-d');
    return [sDate, eDate];
}

export function getLatestMonthDateArrayByDate({date, delayNum = 3, formatValue = 'yyyy-M-d'} = {}) {
    const eDate = date.myFormat(formatValue);
    date.setMonth(date.getMonth() - delayNum);
    const sDate = date.myFormat(formatValue);
    console.log(sDate, eDate);
    return [sDate, eDate];
}

// export function getMonthDateArrayByPrePostSafari2({date, preDelayNum = 6,postDelayNum=6, formatValue = 'yyyy/MM/dd'} = {}) {    
//     const sDate = date.setMonth(date.getMonth() + preDelayNum);
//     const eDate = date.setMonth(date.getMonth()-preDelayNum + postDelayNum);
//     console.log(sDate, eDate);
//     return [sDate, eDate];
// }

// export function getMonthDateArrayByPrePost({date, preDelayNum = 6,postDelayNum=6, formatValue = 'yyyy/MM/dd'} = {}) {    
//     const eDate = date.myFormat(formatValue);
//     date.setMonth(date.getMonth() - preDelayNum);
//     const sDate = date.myFormat(formatValue);
//     console.log(sDate, eDate);
//     return [sDate, eDate];
    
//     // const sDate = date.setMonth(date.getMonth() + preDelayNum);    
//     // const eDate = date.setMonth(date.getMonth() - preDelayNum + postDelayNum);
//     // console.log('bb',sDate, eDate);
//     // return [sDate, eDate];
// }


export function getCurrentYear() {
    return new Date().getFullYear().toString();
}

export function getYearMonthDayBySeverTime(severTime) {
    return severTime?.split('T')[0] ?? '';
}

export function getCurrentYMD() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

export function getCurrentYM() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }

    var currentdate = year + seperator1 + month;
    return currentdate;
  }